import React from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

import {Container, Row, Col} from './BootstrapGrid';
import {Headline, Subheading} from './Typography';


const MadeInSFSection = muiThemeable()((props) => (
  <div  style={{backgroundColor: props.muiTheme.palette.primary2Color,
                color: props.muiTheme.palette.alternateTextColor}}>
    <Container>
      <Row>
        <Col
          style={{height: "100px"}}
          cols={12} align="middle">
          <div style={{
              textAlign: "center",
              position: 'relative',
              top: '50%',
              transform: 'translateY(-50%)'
            }}>

            <Subheading alternateColor={true}>
              Proudly serving you from Hayes Valley, San Francisco
            </Subheading>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
));

export default MadeInSFSection;



// WEBPACK FOOTER //
// ./src/MadeInSFSection.js